import { formatCustomerIndexLabel } from "@/lib/formatters/CustomerIndexFormatter";
import { AllCustomerTargetsTableRow } from "./RowsAndColumnsConfig";

export const customerColumnValueResolver = (item: AllCustomerTargetsTableRow) =>
  formatCustomerIndexLabel(item.customerNo, item.customerIndex);

export const countryColumnValueResolver = (item: AllCustomerTargetsTableRow) =>
  item.country;

export const salesRegionValueResolver = (item: AllCustomerTargetsTableRow) =>
  item.salesRegion ?? "";

export const sellerColumnValueResolver = (item: AllCustomerTargetsTableRow) =>
  item.seller ?? "";

export const statCustomerColumnValueResolver = (
  item: AllCustomerTargetsTableRow
) => formatCustomerIndexLabel(item.statNo, item.statIndex);

export const statNVolumeColumnValueResolver = (
  item: AllCustomerTargetsTableRow
) => item.statNVolume;

export const statRVolumeColumnValueResolver = (
  item: AllCustomerTargetsTableRow
) => item.statRVolume;

export const sailingCatVolumeColumnValueResolver = (
  item: AllCustomerTargetsTableRow
) => item.sailingCat ?? "";

export const unitTypeColumnValueResolver = (item: AllCustomerTargetsTableRow) =>
  item.unitType ?? "";

export const avgLengthColumnValueResolver = (
  item: AllCustomerTargetsTableRow
) => item.avgLength;

export const customerVolumeColumnValueResolver = (
  item: AllCustomerTargetsTableRow
) => item.customerVolume;

export const netColumnValueResolver = (item: AllCustomerTargetsTableRow) =>
  item.net;

export const grossColumnValueResolver = (item: AllCustomerTargetsTableRow) =>
  item.gross;

export const targetColumnValueResolver = (item: AllCustomerTargetsTableRow) =>
  item.target;

export const getHeaderRowOffsetTop = (
  isRowsSelected: boolean,
  isWarningVisible: boolean,
  isSearchSkippedVisible: boolean
) => {
  if (isWarningVisible || (isSearchSkippedVisible && !isRowsSelected)) {
    return "266px";
  }
  if (isRowsSelected) {
    return "210px";
  }
  return "216px";
};
